import React, { memo } from 'react';
import styles from './listItem.module.scss';

const ListItem = ({ children, className, ...resp }) =>
    <>
        <div className={`${className} ${styles.listItem}`} {...resp}>
            {children}
        </div>
        <hr />
    </>

export default memo(ListItem);